<template>
  <component
    :is="tag"
    v-if="showToolTip"
    v-tooltip="{ content: value, trigger: 'hover' }"
    class="tooltip-wrap"
    @click.stop="emitClicked"
  >
    <a v-if="tabbable" href="javascript:void(0)" @click.stop="emitClicked">
      {{ display }}
    </a>
    <template v-else>
      {{ display }}
    </template>>
  </component>
  <component :is="tag" v-else @click="emitClicked">

    <a v-if="tabbable" href="javascript:void(0)" @click.stop="emitClicked">
    {{ display }}
    </a>
    <template v-else>
      {{ display }}
    </template>
  </component>
</template>
<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      maxChars: {
        type: Number,
        default: 22
      },
      tag: {
        type: String,
        default: 'span'
      },
      tabbable: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      showToolTip() {
        return this.value.length > this.maxChars
      },
      display() {
        if (this.showToolTip) {
          return this.value.substring(0, this.maxChars - 1) + '...'
        } else {
          return this.value
        }
      }
    },
    methods: {
      emitClicked() {
        this.$emit('clicked')
      }
    }
  }
</script>
